import pino from "pino";
import config from "@/configurations/index";

const logger = pino({
  level: config.AppEnv === "production" ? "error" : "debug",
});

export default logger;
